import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import { DialogContentProps } from 'components/dialog/types';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';

import { DefaultDialog } from './aisuk-default-dialog';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
    dialog: {
      width: 600,
    },
    dialogTitle: {
      fontWeight: 'bold',
    },
    dialogActions: {
      padding: '8px 24px',
    },
    quote: {
      '& textarea': {
        lineHeight: 1.5,
      },
    },
  })
);

export const BasicQuoteDialog = ({
  initialValues,
}: DialogContentProps<{
  quoteContent: string;
}>) => {
  const classes = useStyles();
  const { showNotification } = useContext(NotificationCtx);

  const handleCopyQuoteToClipboard = (e: React.MouseEvent) => {
    e.preventDefault();

    const cb = navigator.clipboard;

    cb.writeText(initialValues?.quoteContent ?? '').then(() =>
      showNotification(
        'Citace byla úspěšně skopírovaná.',
        NotificationVariant.SUCCESS,
        3000
      )
    );
  };

  return (
    <DefaultDialog
      minWidth={600}
      title="Citace"
      actions={
        <Button
          color="primary"
          onClick={handleCopyQuoteToClipboard}
          startIcon={<FileCopyIcon />}
        >
          Kopírovat
        </Button>
      }
    >
      <TextField
        className={classes.quote}
        fullWidth
        value={initialValues?.quoteContent ?? ''}
        multiline
        InputProps={{
          disableUnderline: true,
        }}
      />
    </DefaultDialog>
  );
};
